import React, { FunctionComponent } from 'react'
import { Path, Rect, Svg } from 'react-native-svg'

type WorkLifeProps = {
  size?: number
}

export const CheckMarkBullet: FunctionComponent<WorkLifeProps> = ({ size = 25 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 25 25'>
      <Path
        d='M9.18557 18.51C8.85488 18.51 8.5242 18.3843 8.27274 18.1311L4.39752 14.2559C3.89288 13.7512 3.89288 12.9348 4.39752 12.4302C4.90216 11.9256 5.71854 11.9256 6.22318 12.4302L9.18557 15.3909L17.3149 7.26324C17.8195 6.75861 18.6359 6.75861 19.1406 7.26324C19.6452 7.76788 19.6452 8.58426 19.1406 9.0889L10.0984 18.1311C9.84694 18.3843 9.51625 18.51 9.18557 18.51Z'
        fill='#3D701A'
      />
    </Svg>
  )
}

export const WorkLifeIconLaw: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        d='M29.447 21.0539C29.2982 21.3014 29.2184 21.5843 29.2159 21.873C29.2159 23.9621 30.0458 25.9656 31.523 27.4428C33.0002 28.92 35.0037 29.7498 37.0927 29.7498C39.1818 29.7498 41.1853 28.92 42.6624 27.4428C44.1396 25.9656 44.9695 23.9621 44.9695 21.873C44.967 21.5843 44.8872 21.3014 44.7384 21.0539L38.437 10.5515C38.3189 10.3222 38.1364 10.1323 37.9119 10.0054C37.6705 9.8627 37.3941 9.78998 37.1137 9.79532C26.6982 9.79532 21.3942 9.79532 11.887 9.79532C11.6073 9.79513 11.3323 9.8675 11.0888 10.0054C10.8643 10.1323 10.6818 10.3222 10.5637 10.5515L4.2623 21.0539C4.11353 21.3014 4.03375 21.5843 4.03125 21.873C4.03125 23.9621 4.86112 25.9656 6.3383 27.4428C7.81549 28.92 9.81898 29.7498 11.908 29.7498C13.9971 29.7498 16.0006 28.92 17.4778 27.4428C18.9549 25.9656 19.7848 23.9621 19.7848 21.873C19.7823 21.5843 19.7025 21.3014 19.5538 21.0539L14.6596 12.946C26.5192 12.946 23.9556 12.946 34.2151 12.946L29.447 21.0539ZM15.4158 20.2977H8.35823L11.887 14.4374L15.4158 20.2977ZM37.0927 14.4374L40.6215 20.2977H33.5639L37.0927 14.4374Z'
        fill='#3BA5B5'
      />
      <Path
        d='M30.0139 9.79526C29.7449 8.85597 29.2413 8.00061 28.5505 7.30975C27.8596 6.61889 27.0042 6.11528 26.065 5.84636C25.238 5.60949 23.9329 5.55457 22.9143 5.84636C21.975 6.11528 21.1196 6.61889 20.4288 7.30975C19.7379 8.00061 19.2343 8.85597 18.9654 9.79526C18.6964 10.7345 18.6307 11.2879 18.8603 12.946C19.1293 13.8852 19.6329 14.7406 20.3237 15.4315C21.0146 16.1223 21.8699 16.6259 22.8092 16.8949V28.1744C22.804 29.9652 22.0975 31.6828 20.841 32.9588C19.1103 34.7166 16.5785 35.1697 14.0063 35.3045C10.9072 35.4669 8.21094 37.6739 8.21094 40.7773C8.21638 41.1934 8.3841 41.5909 8.67836 41.8852C8.97263 42.1795 9.37017 42.3472 9.78629 42.3526H39.1929C39.609 42.3472 40.0066 42.1795 40.3009 41.8852C40.5951 41.5909 40.7628 41.1934 40.7683 40.7773C40.7727 37.6737 38.0725 35.464 34.9727 35.3111C32.3782 35.1832 29.8174 34.7423 28.0705 32.9954C26.7915 31.7164 26.0705 29.9832 26.065 28.1744V16.8949C27.0042 16.6259 27.8596 16.1223 28.5505 15.4315C29.2413 14.7406 29.7449 13.8852 30.0139 12.946C30.2081 12.2674 30.333 10.9101 30.0139 9.79526Z'
        fill='#85CCD5'
      />
    </Svg>
  )
}

export const WorkLifeIconFinancial: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Rect x={8.1416} y={22.7233} width={11.5371} height={19.8047} fill='#3BA5B5' />
      <Rect x={28.3213} y={22.7233} width={11.5371} height={19.8047} fill='#3BA5B5' />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.36825 23.0243C17.8118 23.0243 34.4568 23.0243 40.6325 23.0243C42.7516 23.0243 44.4695 21.3162 44.4695 19.2091C44.4695 17.9067 43.8013 16.6942 42.6972 15.9934L26.3606 5.62346C24.9213 4.70982 23.0795 4.70982 21.6402 5.62346L5.30359 15.9934C4.19949 16.6942 3.53125 17.9067 3.53125 19.2091C3.53125 21.3162 5.24913 23.0243 7.36825 23.0243Z'
        fill='#85CCD5'
      />
      <Rect x={3.53125} y={39.6207} width={40.9382} height={5.21032} rx={2.60516} fill='#85CCD5' />
    </Svg>
  )
}

export const WorkLifeIconFamily: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        d='M8.5885 43.7088C7.3069 43.7088 6.2821 42.4752 6.3445 41.0016C6.5389 36.4704 5.6629 27.816 9.1021 24.5232C10.2589 23.4168 12.8581 21.6024 14.1781 22.1496C18.8605 24.0912 20.4325 22.6704 22.2589 22.2096C24.0421 21.7584 26.6317 24.0384 27.5653 25.4736C29.6725 28.7064 28.8637 36.8448 28.9213 41.0808C28.9405 42.5256 27.9301 43.7088 26.6749 43.7088H8.5885Z'
        fill='#85CCD5'
      />
      <Path
        d='M24.6923 14.784C24.6923 18.1146 21.941 21.12 18.5483 21.12C15.1556 21.12 12.4043 18.1146 12.4043 14.784C12.4043 11.4533 15.1556 8.448 18.5483 8.448C21.941 8.448 24.6923 11.4533 24.6923 14.784Z'
        fill='#85CCD5'
      />
      <Path
        d='M27.927 43.7928C26.9094 43.7928 26.0934 42.8136 26.1438 41.64C26.2998 38.04 25.6014 31.164 28.335 28.548C29.2542 27.6672 31.3206 26.2272 32.3694 26.664C36.0894 28.2072 37.3398 27.0768 38.7894 26.712C40.239 26.3472 42.2646 28.164 43.0062 29.304C44.679 31.872 44.0382 38.34 44.0838 41.7048C44.1006 42.852 43.2966 43.7928 42.3006 43.7928H27.927Z'
        fill='#3BA5B5'
      />
      <Path
        d='M40.4361 20.736C40.4361 23.3596 38.2011 25.728 35.4441 25.728C32.6872 25.728 30.4521 23.3596 30.4521 20.736C30.4521 18.1124 32.6872 15.744 35.4441 15.744C38.2011 15.744 40.4361 18.1124 40.4361 20.736Z'
        fill='#3BA5B5'
      />
    </Svg>
  )
}

export const WorkLifeIconHearts: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        d='M29.5715 30.9911C29.4659 31.1759 29.3507 31.3607 29.2307 31.5407C26.0267 36.3071 18.5963 42.8903 16.1267 43.1615C14.9579 43.2911 7.52028 37.3439 4.06428 31.1351C2.12988 27.6551 1.43868 24.0959 3.81228 21.4703C5.93868 19.1207 8.18028 18.7103 10.1867 19.1495C13.7963 19.9343 16.6355 23.4743 16.6355 23.4743C16.6355 23.4743 18.0011 21.8495 20.1467 20.8199C20.1683 20.8607 20.1923 20.8991 20.2163 20.9399C22.5995 24.9815 26.7155 28.8647 29.5715 30.9911Z'
        fill='#3BA5B5'
      />
      <Path
        d='M29.5713 30.9911C26.7153 28.8647 22.5993 24.9815 20.2161 20.9399C20.1921 20.8991 20.1681 20.8607 20.1465 20.8199C22.2225 19.8239 25.0329 19.3895 28.0377 21.5423C30.9105 23.5991 31.4097 27.7415 29.5713 30.9911Z'
        fill='#3BA5B5'
      />
      <Path
        d='M45.3851 20.7167C42.3011 25.5647 35.0387 32.3303 32.5763 32.6615C32.1803 32.7143 31.0427 32.0855 29.5715 30.9911C31.4099 27.7415 30.9107 23.5991 28.0379 21.5423C25.0331 19.3895 22.2227 19.8239 20.1467 20.8199C18.1787 17.4311 17.4419 13.9391 19.7243 11.2871C21.7907 8.8847 24.0203 8.4191 26.0363 8.8055C29.6651 9.5015 32.5931 12.9695 32.5931 12.9695C32.5931 12.9695 37.7291 6.5351 43.9427 10.7543C47.0363 12.8519 47.5307 17.3471 45.3851 20.7167Z'
        fill='#85CCD5'
      />
    </Svg>
  )
}

export const WorkLifeIconPencil: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        d='M41.2927 14.9281L17.6191 40.3729C17.2471 40.7737 16.7431 41.0329 16.1791 41.1193L11.8279 41.7817L9.18792 42.1849C7.95672 42.3745 6.58392 41.1001 6.68712 39.8617L6.89832 37.2001L7.24152 32.8129C7.28712 32.2441 7.51032 31.7233 7.88232 31.3225L31.5631 5.87528C32.3695 5.00888 33.9583 5.16968 35.1079 6.24248L40.6759 11.4217C41.8231 12.4897 42.1015 14.0593 41.2951 14.9281H41.2927Z'
        fill='#85CCD5'
      />
      <Path
        d='M11.8287 41.7817L9.18866 42.185C7.95746 42.3746 6.58706 41.1002 6.68786 39.8594L6.89906 37.1978L11.8263 41.7817H11.8287Z'
        fill='#3BA5B5'
      />
      <Path
        d='M41.6188 14.5777L38.0836 18.3768L28.3516 9.32405L31.8868 5.52485C32.5132 4.85045 33.9556 5.17205 35.1076 6.24245L40.6732 11.4193C41.8204 12.4873 42.2452 13.9032 41.6188 14.5752V14.5777Z'
        fill='#3BA5B5'
      />
    </Svg>
  )
}

export const WorkLifeIconDependentCare: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        d='M41.9601 15.6216C40.2993 18.1752 36.4137 21.7248 35.1057 21.888C34.4865 21.9648 30.4953 18.8736 28.6137 15.6096C27.5601 13.7808 27.1641 11.8992 28.4025 10.488C29.5113 9.22564 30.6969 8.99043 31.7625 9.20643C33.6825 9.59523 35.2161 11.448 35.2161 11.448C35.2161 11.448 37.9737 8.06403 41.2449 10.332C42.8721 11.46 43.1121 13.8456 41.9577 15.6216H41.9601Z'
        fill='#3BA5B5'
      />
      <Path
        d='M1.37336 36.8905C1.39256 36.6889 1.43816 36.5041 1.51976 36.3457C1.65656 36.0817 1.91336 35.9041 2.16056 35.7385C7.39976 32.2081 12.6294 28.6513 18.063 25.4257C19.8102 24.3889 21.7326 23.0449 23.7342 22.5505C27.315 21.6625 26.9046 24.2545 25.8606 25.6825C24.819 27.1105 21.5766 29.3089 22.2894 30.7561C23.0022 32.2033 26.6238 34.3081 34.1502 32.6449C41.6766 30.9841 43.6878 26.9281 46.1118 29.3737C48.5358 31.8169 40.6182 39.8425 34.7814 41.7265C28.9446 43.6105 20.019 42.4009 16.827 43.7737C15.627 44.2897 14.4582 44.8681 13.2798 45.4297C12.2598 45.9145 11.2662 46.6273 10.1814 46.9489C8.66456 47.3953 6.06056 45.1609 5.04536 44.2081C3.95576 43.1857 3.06536 41.9545 2.43656 40.5985C2.05496 39.7753 1.26536 38.0425 1.37096 36.8953L1.37336 36.8905Z'
        fill='#85CCD5'
      />
    </Svg>
  )
}

export const WorkLifeIconSquares: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        d='M31.2203 9.61124V17.4642H21.1874C19.5636 17.4642 18.2492 18.76 18.2492 20.3555V30.528H9.96651C8.34277 30.528 7.02832 29.2322 7.02832 27.6344V9.61124C7.02832 8.01343 8.34511 6.71997 9.96651 6.71997H28.2821C29.9059 6.71997 31.2203 8.01574 31.2203 9.61124Z'
        fill='#85CCD5'
      />
      <Path
        d='M31.2201 17.472V27.6362C31.2201 29.233 29.8946 30.528 28.2626 30.528H18.1641V20.3616C18.1641 18.7647 19.4895 17.472 21.1215 17.472H31.2201Z'
        fill='#3BA5B5'
      />
      <Path
        d='M41.9721 20.3636V38.3885C41.9721 39.9865 40.6762 41.28 39.0805 41.28H21.0556C19.4576 41.28 18.1641 39.9841 18.1641 38.3885V30.537H28.0377C29.6357 30.537 30.9293 29.2411 30.9293 27.6432V17.472H39.0805C40.6785 17.472 41.9721 18.7679 41.9721 20.3636Z'
        fill='#85CCD5'
      />
    </Svg>
  )
}

export const WorkLifeIconIdentity: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        d='M24.5 4.49988C18.0119 4.49988 12.2417 7.65809 8.32744 12.5644C7.81079 13.212 7.91695 14.1558 8.56454 14.6724C9.21213 15.1891 10.1559 15.0829 10.6726 14.4353C14.0855 10.1574 19.0282 7.49988 24.5 7.49988C29.9718 7.49988 34.9145 10.1574 38.3274 14.4353C38.8441 15.0829 39.7879 15.1891 40.4355 14.6724C41.0831 14.1558 41.1892 13.212 40.6726 12.5644C36.7583 7.65809 30.9881 4.49988 24.5 4.49988Z'
        fill='#3BA5B5'
      />
      <Path
        d='M6.5 28.2239C6.5 18.4106 14.5836 10.4999 24.5 10.4999C34.4164 10.4999 42.5 18.4106 42.5 28.2239C42.5 32.0634 39.3409 35.1319 35.4994 35.1319C31.6579 35.1319 28.4988 32.0634 28.4988 28.2239C28.4988 26.0893 26.7313 24.3159 24.4982 24.3159C22.265 24.3159 20.4976 26.0893 20.4976 28.2239C20.4976 33.4857 23.3128 38.1133 27.5674 40.721C28.2737 41.1539 28.4953 42.0774 28.0624 42.7837C27.6295 43.49 26.706 43.7117 25.9997 43.2788C20.9074 40.1576 17.4976 34.5892 17.4976 28.2239C17.4976 24.3844 20.6567 21.3159 24.4982 21.3159C28.3397 21.3159 31.4988 24.3844 31.4988 28.2239C31.4988 30.3584 33.2662 32.1319 35.4994 32.1319C37.7326 32.1319 39.5 30.3584 39.5 28.2239C39.5 20.1151 32.8077 13.4999 24.5 13.4999C16.1923 13.4999 9.5 20.1151 9.5 28.2239C9.5 30.1069 9.71436 31.9425 10.1096 33.7145C10.29 34.5231 9.78074 35.3248 8.97218 35.5051C8.16363 35.6855 7.36196 35.1762 7.1816 34.3677C6.7405 32.3902 6.5 30.3356 6.5 28.2239Z'
        fill='#3BA5B5'
      />
      <Path
        d='M24.5 26.9999C25.3284 26.9999 26 27.6714 26 28.4999C26 33.3587 30.3097 37.4999 35.8867 37.4999C35.9873 37.4999 36.0663 37.495 36.1829 37.4877C36.2479 37.4837 36.3246 37.4789 36.4233 37.4738C37.2506 37.4315 37.9557 38.0678 37.998 38.8952C38.0404 39.7225 37.404 40.4275 36.5767 40.4699C36.5459 40.4715 36.5065 40.4739 36.461 40.4767C36.3077 40.4862 36.0849 40.4999 35.8867 40.4999C28.8865 40.4999 23 35.24 23 28.4999C23 27.6714 23.6716 26.9999 24.5 26.9999Z'
        fill='#3BA5B5'
      />
      <Path
        d='M24.5 17.9999C19.6171 17.9999 15.5 22.2441 15.5 27.6826C15.5 32.1546 16.8177 36.2857 19.0488 39.6751C19.5043 40.3671 19.3126 41.2973 18.6206 41.7528C17.9287 42.2083 16.9985 42.0166 16.543 41.3246C13.9942 37.4527 12.5 32.7495 12.5 27.6826C12.5 20.7679 17.7851 14.9999 24.5 14.9999C31.2149 14.9999 36.5 20.7679 36.5 27.6826C36.5 28.511 35.8284 29.1826 35 29.1826C34.1716 29.1826 33.5 28.511 33.5 27.6826C33.5 22.2441 29.3829 17.9999 24.5 17.9999Z'
        fill='#3BA5B5'
      />
    </Svg>
  )
}
export const WorkLifeIconMindfulness: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        d='M24.8984 43.9392C12.0872 39.672 4.94724 26.004 8.14644 12.6649C8.26884 12.1561 8.79443 11.8657 9.26723 12.0409C21.8144 16.7376 28.5848 30.6144 24.8984 43.9368V43.9392Z'
        fill='#85CCD5'
      />
      <Path
        d='M23.7174 38.8967C21.6558 27.3983 28.7718 16.3703 39.8358 13.3487C40.2582 13.2335 40.683 13.5143 40.7454 13.9463C42.387 25.4207 34.9638 36.2543 23.7174 38.8967Z'
        fill='#85CCD5'
      />
      <Path
        d='M24.898 43.9391C14.7316 33.7439 14.3764 17.4095 23.7268 6.45591C24.0076 6.12711 24.5116 6.11511 24.8092 6.42951C34.6108 16.8455 34.606 33.1895 24.898 43.9391Z'
        fill='#85CCD5'
      />
      <Path
        d='M24.9291 45.0791C24.9075 44.6855 24.7803 44.2751 24.8979 43.8959C28.9491 30.912 33.5691 30.9168 45.9075 21.8184C46.6899 21.2424 47.2779 21.8208 47.2851 22.2264C47.2875 22.38 47.2899 22.5336 47.2899 22.6872C47.2899 35.0424 37.2819 45.0623 24.9291 45.0791Z'
        fill='#3BA5B5'
      />
      <Path
        d='M25.0563 45.0744C25.0515 44.6808 25.1523 44.2632 25.0107 43.8936C20.1123 31.2048 15.5019 31.5144 2.59234 23.2488C1.77394 22.7256 1.22674 23.3424 1.24354 23.7456C1.25074 23.8992 1.25794 24.0528 1.26994 24.2064C2.08354 36.5352 12.7323 45.8736 25.0563 45.0744Z'
        fill='#3BA5B5'
      />
    </Svg>
  )
}
export const WorkLifeIconCalendar: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.1719 3.44397C16.0003 3.44397 16.6719 4.11554 16.6719 4.94397V9.32431C16.6719 10.1527 16.0003 10.8243 15.1719 10.8243C14.3434 10.8243 13.6719 10.1527 13.6719 9.32431V4.94397C13.6719 4.11554 14.3434 3.44397 15.1719 3.44397Z'
        fill='#3BA5B5'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M34.0137 3.44397C34.8421 3.44397 35.5137 4.11554 35.5137 4.94397V9.32431C35.5137 10.1527 34.8421 10.8243 34.0137 10.8243C33.1852 10.8243 32.5137 10.1527 32.5137 9.32431V4.94397C32.5137 4.11554 33.1852 3.44397 34.0137 3.44397Z'
        fill='#3BA5B5'
      />
      <Path
        d='M6.5 15.762C6.5 13.2418 6.5 11.9817 6.99047 11.0191C7.4219 10.1723 8.11031 9.48391 8.95704 9.05248C9.91964 8.56201 11.1798 8.56201 13.7 8.56201H35.3C37.8202 8.56201 39.0803 8.56201 40.0429 9.05248C40.8897 9.48391 41.5781 10.1723 42.0095 11.0191C42.5 11.9817 42.5 13.2418 42.5 15.762C42.5 16.1947 42.1493 16.5454 41.7166 16.5454L7.28338 16.5454C6.85073 16.5454 6.5 16.1947 6.5 15.762Z'
        fill='#3BA5B5'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.5 22.003C6.5 21.1428 6.5 20.7126 6.66741 20.3841C6.81468 20.0951 7.04965 19.8601 7.33867 19.7128C7.66724 19.5454 8.09736 19.5454 8.9576 19.5454L40.0424 19.5454C40.9026 19.5454 41.3327 19.5454 41.6613 19.7128C41.9503 19.8601 42.1853 20.0951 42.3326 20.3841C42.5 20.7127 42.5 21.1428 42.5 22.003V37.1832C42.5 39.7035 42.5 40.9636 42.0095 41.9262C41.5781 42.7729 40.8897 43.4613 40.0429 43.8928C39.0803 44.3832 37.8202 44.3832 35.3 44.3832H13.7C11.1798 44.3832 9.91964 44.3832 8.95704 43.8928C8.11031 43.4613 7.4219 42.7729 6.99047 41.9262C6.5 40.9636 6.5 39.7035 6.5 37.1832V22.003Z'
        fill='#85CCD5'
      />
      <Path
        d='M14.0234 25.2C14.0234 24.78 14.0234 24.5699 14.1052 24.4095C14.1771 24.2684 14.2918 24.1537 14.4329 24.0817C14.5934 24 14.8034 24 15.2234 24H17.2988C17.7189 24 17.9289 24 18.0893 24.0817C18.2304 24.1537 18.3452 24.2684 18.4171 24.4095C18.4988 24.5699 18.4988 24.78 18.4988 25.2V27.2754C18.4988 27.6954 18.4988 27.9055 18.4171 28.0659C18.3452 28.207 18.2304 28.3217 18.0893 28.3936C17.9289 28.4754 17.7189 28.4754 17.2988 28.4754H15.2234C14.8034 28.4754 14.5934 28.4754 14.4329 28.3936C14.2918 28.3217 14.1771 28.207 14.1052 28.0659C14.0234 27.9055 14.0234 27.6954 14.0234 27.2754V25.2Z'
        fill='#3BA5B5'
      />
      <Path
        d='M14.0234 32.7015C14.0234 32.2814 14.0234 32.0714 14.1052 31.911C14.1771 31.7699 14.2918 31.6551 14.4329 31.5832C14.5934 31.5015 14.8034 31.5015 15.2234 31.5015H17.2988C17.7189 31.5015 17.9289 31.5015 18.0893 31.5832C18.2304 31.6551 18.3452 31.7699 18.4171 31.911C18.4988 32.0714 18.4988 32.2814 18.4988 32.7015V34.7769C18.4988 35.1969 18.4988 35.4069 18.4171 35.5674C18.3452 35.7085 18.2304 35.8232 18.0893 35.8951C17.9289 35.9769 17.7189 35.9769 17.2988 35.9769H15.2234C14.8034 35.9769 14.5934 35.9769 14.4329 35.8951C14.2918 35.8232 14.1771 35.7085 14.1052 35.5674C14.0234 35.4069 14.0234 35.1969 14.0234 34.7769V32.7015Z'
        fill='#3BA5B5'
      />
      <Path
        d='M22.4727 25.2C22.4727 24.78 22.4727 24.5699 22.5544 24.4095C22.6263 24.2684 22.741 24.1537 22.8822 24.0817C23.0426 24 23.2526 24 23.6727 24H25.748C26.1681 24 26.3781 24 26.5385 24.0817C26.6797 24.1537 26.7944 24.2684 26.8663 24.4095C26.948 24.5699 26.948 24.78 26.948 25.2V27.2754C26.948 27.6954 26.948 27.9055 26.8663 28.0659C26.7944 28.207 26.6797 28.3217 26.5385 28.3936C26.3781 28.4754 26.1681 28.4754 25.748 28.4754H23.6727C23.2526 28.4754 23.0426 28.4754 22.8822 28.3936C22.741 28.3217 22.6263 28.207 22.5544 28.0659C22.4727 27.9055 22.4727 27.6954 22.4727 27.2754V25.2Z'
        fill='#3BA5B5'
      />
      <Path
        d='M22.4727 32.7015C22.4727 32.2814 22.4727 32.0714 22.5544 31.911C22.6263 31.7699 22.741 31.6551 22.8822 31.5832C23.0426 31.5015 23.2526 31.5015 23.6727 31.5015H25.748C26.1681 31.5015 26.3781 31.5015 26.5385 31.5832C26.6797 31.6551 26.7944 31.7699 26.8663 31.911C26.948 32.0714 26.948 32.2814 26.948 32.7015V34.7769C26.948 35.1969 26.948 35.4069 26.8663 35.5674C26.7944 35.7085 26.6797 35.8232 26.5385 35.8951C26.3781 35.9769 26.1681 35.9769 25.748 35.9769H23.6727C23.2526 35.9769 23.0426 35.9769 22.8822 35.8951C22.741 35.8232 22.6263 35.7085 22.5544 35.5674C22.4727 35.4069 22.4727 35.1969 22.4727 34.7769V32.7015Z'
        fill='#3BA5B5'
      />
      <Path
        d='M30.9229 25.2C30.9229 24.78 30.9229 24.5699 31.0046 24.4095C31.0765 24.2684 31.1912 24.1537 31.3324 24.0817C31.4928 24 31.7028 24 32.1229 24H34.1982C34.6183 24 34.8283 24 34.9887 24.0817C35.1299 24.1537 35.2446 24.2684 35.3165 24.4095C35.3982 24.5699 35.3982 24.78 35.3982 25.2V27.2754C35.3982 27.6954 35.3982 27.9055 35.3165 28.0659C35.2446 28.207 35.1299 28.3217 34.9887 28.3936C34.8283 28.4754 34.6183 28.4754 34.1982 28.4754H32.1229C31.7028 28.4754 31.4928 28.4754 31.3324 28.3936C31.1912 28.3217 31.0765 28.207 31.0046 28.0659C30.9229 27.9055 30.9229 27.6954 30.9229 27.2754V25.2Z'
        fill='#3BA5B5'
      />
    </Svg>
  )
}

export const WorkLifeIconInclusion: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        d='M36.6706 16.4765C36.6706 17.5596 36.5252 18.6063 36.249 19.6022C35.2677 19.3357 34.233 19.1927 33.1645 19.1927C29.8571 19.1927 26.8671 20.5569 24.73 22.757C22.5929 20.5569 19.6029 19.1927 16.2954 19.1927C15.348 19.1927 14.4249 19.3042 13.5429 19.5174C13.2836 18.5482 13.1455 17.5281 13.1455 16.4765C13.1455 9.98041 18.4107 4.71277 24.9093 4.71277C31.4078 4.71277 36.6706 9.98041 36.6706 16.4765Z'
        fill='#85CCD5'
      />
      <Path
        d='M36.2495 19.6022C35.1228 23.7093 31.8226 26.9173 27.6623 27.9156C27.1365 25.9433 26.1116 24.1769 24.7305 22.757C26.8676 20.5569 29.8576 19.1927 33.165 19.1927C34.2335 19.1927 35.2682 19.3357 36.2495 19.6022Z'
        fill='#3BA5B5'
      />
      <Path
        d='M44.9287 30.9566C44.9287 37.4527 39.6611 42.7179 33.165 42.7179C29.8576 42.7179 26.8676 41.3537 24.7305 39.1536C26.79 37.0359 28.0597 34.1428 28.0597 30.9566C28.0597 29.905 27.9216 28.8849 27.6623 27.9157C31.8226 26.9174 35.1228 23.7093 36.2495 19.6023C41.2506 20.9568 44.9287 25.5266 44.9287 30.9566Z'
        fill='#85CCD5'
      />
      <Path
        d='M24.73 22.757C23.3683 24.1551 22.3531 25.8924 21.8224 27.8308C17.7905 26.738 14.6188 23.5542 13.543 19.5174C14.4249 19.3042 15.3481 19.1927 16.2955 19.1927C19.6029 19.1927 22.5929 20.5569 24.73 22.757Z'
        fill='#3BA5B5'
      />
      <Path
        d='M27.6617 27.9156C26.7798 28.1288 25.8566 28.2402 24.9092 28.2402C23.8406 28.2402 22.806 28.0973 21.8223 27.8308C22.3529 25.8923 23.3682 24.155 24.7299 22.757C26.111 24.1768 27.1359 25.9432 27.6617 27.9156Z'
        fill='#3BA5B5'
      />
      <Path
        d='M28.0598 30.9565C28.0598 34.1428 26.7902 37.0359 24.7306 39.1536C22.671 37.0359 21.4014 34.1428 21.4014 30.9565C21.4014 29.8734 21.5467 28.8267 21.823 27.8308C22.8067 28.0973 23.8413 28.2403 24.9099 28.2403C25.8573 28.2403 26.7805 28.1288 27.6624 27.9156C27.9217 28.8848 28.0598 29.9049 28.0598 30.9565Z'
        fill='#3BA5B5'
      />
      <Path
        d='M24.7305 39.1535C22.5934 41.3536 19.6034 42.7177 16.296 42.7177C9.79987 42.7177 4.53223 37.4525 4.53223 30.9564C4.53223 25.4053 8.37513 20.7555 13.5434 19.5173C14.6192 23.5541 17.791 26.7379 21.8229 27.8307C21.5467 28.8266 21.4013 29.8733 21.4013 30.9564C21.4013 34.1427 22.6709 37.0357 24.7305 39.1535Z'
        fill='#85CCD5'
      />
    </Svg>
  )
}
export const WorkLifeIconLaptop: FunctionComponent<WorkLifeProps> = ({ size = 48 }) => {
  return (
    <Svg width={size} height={size} viewBox='0 0 49 48'>
      <Path
        d='M41.3002 10.7207V34.6823C41.3002 35.1959 40.8994 35.6135 40.4026 35.6135H8.5978C8.1034 35.6135 7.7002 35.1935 7.7002 34.6823V10.7207C7.7002 10.2071 8.101 9.78955 8.5978 9.78955H40.4026C40.897 9.78955 41.3002 10.2071 41.3002 10.7207Z'
        fill='#85CCD5'
      />
      <Path
        d='M32.2898 34.2121H17.069C17.0642 31.1545 16.9514 26.8825 18.905 25.0849C19.685 24.3649 21.4394 23.1889 22.3298 23.5441C25.4858 24.8041 26.5466 23.8825 27.7778 23.5825C28.9826 23.2897 30.7274 24.7681 31.3562 25.6993C32.5322 27.4369 32.3618 31.3561 32.2898 34.2121Z'
        fill='#3BA5B5'
      />
      <Path
        d='M29.0457 18.4775C29.0457 20.6975 27.3441 22.7015 25.2465 22.7015C23.1489 22.7015 21.4473 20.6975 21.4473 18.4775C21.4473 16.2575 23.1489 14.2535 25.2465 14.2535C27.3441 14.2535 29.0457 16.2575 29.0457 18.4775Z'
        fill='#3BA5B5'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.93359 35.5176C1.93359 34.1391 3.05109 33.0216 4.42959 33.0216H44.572C45.9505 33.0216 47.068 34.1391 47.068 35.5176C47.068 36.8961 45.9505 38.0136 44.572 38.0136H4.42959C3.05109 38.0136 1.93359 36.8961 1.93359 35.5176Z'
        fill='#3BA5B5'
      />
    </Svg>
  )
}
